import Vue from "vue";
var index = /* @__PURE__ */ Vue.extend({
  props: ["params"],
  methods: {
    resolve(value, unmountDelay) {
      this.$emit("resolve", value, unmountDelay);
    },
    reject(error, unmountDelay) {
      this.$emit("reject", error, unmountDelay);
    }
  }
});
const promiseDialogsWrapper = {};
var PromiseDialogsWrapper = /* @__PURE__ */ Vue.extend({
  name: "PromiseDialogsWrapper",
  props: {
    unmountDelay: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogsData: new Map()
    };
  },
  created() {
    if (promiseDialogsWrapper.value) {
      console.error("PromiseDialogsWrapper instance already exists");
      return;
    }
    promiseDialogsWrapper.value = this;
  },
  beforeDestroy() {
    promiseDialogsWrapper.value = void 0;
  },
  methods: {
    add(component, params, unmountDelay) {
      return new Promise((resolve, reject) => {
        this.dialogsData = new Map([
          ...this.dialogsData,
          [
            Symbol(),
            {
              component,
              params,
              promiseResolve: resolve,
              promiseReject: reject,
              unmountDelay
            }
          ]
        ]);
      });
    },
    onResolve(id, result, unmountDelay) {
      var _a;
      (_a = this.dialogsData.get(id)) == null ? void 0 : _a.promiseResolve(result);
      this.unmountDialog(id, unmountDelay);
    },
    onReject(id, error, unmountDelay) {
      var _a;
      (_a = this.dialogsData.get(id)) == null ? void 0 : _a.promiseReject(error);
      this.unmountDialog(id, unmountDelay);
    },
    unmountDialog(id, delay) {
      const unmount = () => {
        this.dialogsData = new Map([...this.dialogsData].filter(([key]) => key !== id));
      };
      if (delay) {
        setTimeout(unmount, delay);
      } else if (this.unmountDelay) {
        setTimeout(unmount, this.unmountDelay);
      } else {
        unmount();
      }
    },
    closeAll(reason, delay) {
      [...this.dialogsData].forEach(([id]) => {
        this.onReject(id, reason, delay);
      });
    }
  },
  render(createElement) {
    return createElement("div", [...this.dialogsData].map(([id, value]) => createElement(value.component, {
      key: id,
      props: {
        params: value.params
      },
      on: {
        resolve: (result, unmountDelay) => {
          this.onResolve(id, result, unmountDelay || value.unmountDelay);
        },
        reject: (error, unmountDelay) => {
          this.onReject(id, error, unmountDelay || value.unmountDelay);
        }
      }
    })));
  }
});
function createPromiseDialog(component, unmountDelay) {
  return function dialogFunction(params) {
    if (!promiseDialogsWrapper.value) {
      throw new Error("PromiseDialogsWrapper instance not found");
    }
    return promiseDialogsWrapper.value.add(component, params, unmountDelay);
  };
}
function closeAllDialogs(reason, unmountDelay) {
  if (!promiseDialogsWrapper.value) {
    throw new Error("PromiseDialogsWrapper instance not found");
  }
  promiseDialogsWrapper.value.closeAll(reason, unmountDelay);
}
export { index as BasePromiseDialog, PromiseDialogsWrapper, closeAllDialogs, createPromiseDialog };
